module.exports = __webpack_public_path__ + "img/041-hurry.09655b8f.svg";